import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/line-up.svg";
var LineUpOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LineUpOutline_default as default
};
